
import { useForm } from 'react-hook-form';
import { loginAuth } from './authServices';
import { forgotPassword } from './authServices';
import { useState } from 'react';

export const useSubmitControler = () => {

    const [message, setMessage] = useState('')
    const [response, setResponse] = useState(null)
    const { register, handleSubmit,formState: { errors } } = useForm({
        mode: "onBlur",
    })

    const onSubmit = async (data) => {
        try {
            //console.log(data)

            const result = await loginAuth(data)


            if (result) {
                setResponse(result)
            }
            //console.log('resultado ', result)
            // setMessage(result.data.message)

        } catch (error) {
          
            console.error('error login: ',error);
            setMessage(error.message)
            setResponse(error.status)
        }
    }

    return { register, handleSubmit, onSubmit, errors,message,response,setMessage,setResponse }
}

export const useForgotPassword = () => {
    const [fpmessage, setfpMessage] = useState('')
    const [fpresponse, setfpResponse] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
    })

    const onResetPassword = async (data) => {
        try {
            //console.log("Datos del formulario:", data);  // Verifica los datos

            const result = await forgotPassword(data)

            //console.log('forgotPassword response: ',result)
            if (result) {
                setfpResponse(result)
            }
            setfpMessage(result.data.message)
        } catch (error) {

            // console.log('error_: ', error)
            setfpMessage(error.message)
            setfpResponse(error.status)
        }
        // console.log('MESSAGE, RESPONSE: ', fpmessage , fpresponse)
    }

    return { reg:register, submitHandler: handleSubmit, onResetPassword, validationErrors:errors, fpmessage, fpresponse,setfpResponse,setfpMessage }
}
